import { __module as t } from "../../../_virtual/isBtcAddress.js";
import { a as e } from "./util/assertString.js";
Object.defineProperty(s = t.exports, "__esModule", {
  value: !0
}), s.default = function (t) {
  return ((0, r.default)(t), t.startsWith("bc1")) ? a.test(t) : o.test(t);
}, r = e && e.__esModule ? e : {
  default: e
}, a = /^(bc1)[a-z0-9]{25,39}$/, o = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/, t.exports = s.default, t.exports.default = s.default;
var s,
  r,
  a,
  o,
  d = t.exports;
export { d as i };